import { toast as sonnerToast } from "sonner";
import type { ReactNode } from "react";

import { ITEM_PROCESS_HIGHLIGHT_DURATION_MS } from "../lib/helpers";

type ToastOptions = {
  description?: string;
  id?: string | number;
  style?: "process";
  icon?: ReactNode;
};

const showToast = (variant: "success" | "error", title: string, options?: ToastOptions) => {
  const method = variant === "success" ? sonnerToast.success : sonnerToast.error;
  method(title, {
    description: options?.description,
    duration: ITEM_PROCESS_HIGHLIGHT_DURATION_MS,
    id: options?.id,
    className: options?.style === "process" ? "process-toast" : undefined,
    icon: options?.icon,
  });
};

export const toast = {
  success(title: string, options?: ToastOptions) {
    showToast("success", title, options);
  },
  error(title: string, options?: ToastOptions) {
    showToast("error", title, options);
  },
};
